import { gql } from '@apollo/client'
import { QUERY_FIELDS_QUERY, QUERY_TABLE_EXISTS, QUERY_COLUMN_EXISTS, USER_BY_EMAIL_QUERY, OBJECT_TYPE_BY_NAME_QUERY, SEARCH_BY_NAME_QUERY, OPERATORS_QUERY } from '../graphql'
import { FIELD_ID, ACTION_TYPE, FIELD_TYPE, CHOICE_TYPE, BEHAVIOR_TYPE } from '../constants'
import { makeInteger, getFieldType } from '../utils'

const QUERY_FIELDS = gql(QUERY_FIELDS_QUERY)
const TABLE_EXISTS = gql(QUERY_TABLE_EXISTS)
const COLUMN_EXISTS = gql(QUERY_COLUMN_EXISTS)
const USER_BY_EMAIL = gql(USER_BY_EMAIL_QUERY)
const OBJECT_TYPE_BY_NAME = gql(OBJECT_TYPE_BY_NAME_QUERY)
const SEARCH_BY_NAME = gql(SEARCH_BY_NAME_QUERY)
const OPERATORS = gql(OPERATORS_QUERY)

const document_model = {

  validation_hook: async function validation_hook(fieldInput, objectId, formInputs) {
    const allInputs = window.rootFormInputs
    console.log('document_model.validation_hook', fieldInput, objectId, formInputs, allInputs)

    function getFieldInput(fieldId) {
      return formInputs[fieldId].currentValue
    }

    function getFieldName(fieldId) {
      return formInputs[fieldId].field.name
    }

    let validationMessage = ''
    let fieldType = null  
    let fieldTypeFieldName = ''
    let choiceType = null
    let choiceTableName = ''
    let filter = ''
    console.log('(((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((field input: ',fieldInput)
    switch (makeInteger(fieldInput.field.id)) {

      case FIELD_ID.documentType.field.outFilterText:
        const outFilterType = getFieldInput(FIELD_ID.documentType.field.outFilterType)
        if (!fieldInput.currentValue) {
          if (outFilterType && outFilterType.id) {
            validationMessage = `${fieldInput.field.name} is required when ${getFieldName(FIELD_ID.documentType.field.outFilterType)} is ${outFilterType.name}.`
          }
        }
        break
      case FIELD_ID.documentType.field.inFilterText:
        const inFilterType = getFieldInput(FIELD_ID.documentType.field.inFilterType)
        if (!fieldInput.currentValue) {
          if (inFilterType && inFilterType.id) {
            validationMessage = `${fieldInput.field.name} is required when ${getFieldName(FIELD_ID.documentType.field.inFilterType)} is ${inFilterType.name}.`
          }
        }
        break
      case FIELD_ID.documentType.field.formatText:
        const formatType = getFieldInput(FIELD_ID.documentType.field.formatType)
        if (!fieldInput.currentValue) {
          if (formatType && formatType.id) {
            validationMessage = `${fieldInput.field.name} is required when ${getFieldName(FIELD_ID.documentType.field.formatType)} is ${formatType.name}.`
          }
        }
        break
      case FIELD_ID.documentType.name:
        if (fieldInput.currentValue) {
          const results = await window.apolloClient.query({ query: OBJECT_TYPE_BY_NAME, variables: { name: fieldInput.currentValue } })
          console.log(results)
          if (results.data.objectTypeByName && makeInteger(results.data.objectTypeByName.id) !== makeInteger(objectId)) {
            validationMessage = `Document type name "${fieldInput.currentValue}" is already being used.`
          }
        }
        break
      case FIELD_ID.documentType.field.defaultType:
        fieldType = getFieldInput(FIELD_ID.documentType.field.type)
        if (!fieldInput.currentValue || !fieldInput.currentValue.id) {
          if (fieldType && fieldType.id && makeInteger(fieldType.id) === FIELD_TYPE.yesNo) {
            validationMessage = `${fieldInput.field.name} is required when ${getFieldName(FIELD_ID.documentType.field.type)} is ${fieldType.name}.`
          }
        }
        break
      case FIELD_ID.documentType.field.defaultText:
        fieldType = getFieldInput(FIELD_ID.documentType.field.type)
        if (!fieldInput.currentValue) {
          if (fieldType && fieldType.id && makeInteger(fieldType.id) === FIELD_TYPE.yesNo) {
            validationMessage = `${fieldInput.field.name} is required when ${getFieldName(FIELD_ID.documentType.field.type)} is ${fieldType.name}.`
          }
        }
        break
      case FIELD_ID.documentType.pkColumnName:
      case FIELD_ID.documentType.databaseTableName:
        if (fieldInput.currentValue) {
          if (fieldInput.currentValue.indexOf(' ') >= 0) {
            validationMessage = `${fieldInput.field.name} cannot contain spaces.`
          }
        }
        break
      case FIELD_ID.user.email:
        if (fieldInput.currentValue) {
          const results = await window.apolloClient.query({ query: USER_BY_EMAIL, variables: { email: fieldInput.currentValue } })
          if (results.data.userByEmail && makeInteger(results.data.userByEmail.id) !== makeInteger(objectId)) {
            validationMessage = `${fieldInput.field.name} "${fieldInput.currentValue}" is already being used.`
          }
        }
        break
      case FIELD_ID.query.name:
        if (fieldInput.currentValue) {
          const results = await window.apolloClient.query({ query: SEARCH_BY_NAME, variables: { name: fieldInput.currentValue } })
          if (results.data.searchByName && makeInteger(results.data.searchByName.id) !== makeInteger(objectId)) {
            validationMessage = `${fieldInput.field.name} "${fieldInput.currentValue}" is already being used.`
          }
        }
        break
      case FIELD_ID.documentType.field.referenceTo:
        fieldType = getFieldInput(FIELD_ID.documentType.field.type)
        if (!fieldInput.currentValue) {
          if (fieldType && fieldType.id && makeInteger(fieldType.id) === FIELD_TYPE.referenceList) {
            validationMessage = `${fieldInput.field.name} is required when ${getFieldName(FIELD_ID.documentType.field.type)} is ${fieldType.name}.`
          }
        }
        break
      case FIELD_ID.documentType.field.maxLength:
        if (fieldInput.currentValue) {
          if (makeInteger(fieldInput.currentValue) < 1 || makeInteger(fieldInput.currentValue) > 4000) {
            validationMessage = `${fieldInput.field.name} must be between 1 and 4000.`
          }
        } else {
          fieldType = getFieldInput(FIELD_ID.documentType.field.type)
          if (fieldType && fieldType.id && FIELD_TYPE.requiresMaxLength.indexOf(makeInteger(fieldType.id)) > -1) {
            validationMessage = `${fieldInput.field.name} is required when ${getFieldName(FIELD_ID.documentType.field.type)} is ${fieldType.name}.`
          }
        }
        break
      case FIELD_ID.documentType.field.height:
        fieldType = getFieldInput(FIELD_ID.documentType.field.type)
        if (!fieldInput.currentValue) {
          if (fieldType && fieldType.id && FIELD_TYPE.requiresHeight.indexOf(makeInteger(fieldType.id)) > -1) {
            validationMessage = `${fieldInput.field.name} is required when ${getFieldName(FIELD_ID.documentType.field.type)} is ${fieldType.name}.`
          }
        }
        break
      case FIELD_ID.documentType.field.width:
        fieldType = getFieldInput(FIELD_ID.documentType.field.type)
        if (!fieldInput.currentValue) {
          if (fieldType && fieldType.id && FIELD_TYPE.requiresWidth.indexOf(makeInteger(fieldType.id)) > -1) {
            validationMessage = `${fieldInput.field.name} is required when ${getFieldName(FIELD_ID.documentType.field.type)} is ${fieldType.name}.`
          }
        }
        break
      case FIELD_ID.documentType.field.choiceValue:
        choiceType = getFieldInput(FIELD_ID.documentType.field.choiceType)
        if (choiceType && choiceType.id && (makeInteger(choiceType.id) === CHOICE_TYPE.sql || makeInteger(choiceType.id) === CHOICE_TYPE.useHook)) {
          if (!fieldInput.currentValue) {
            validationMessage = `${fieldInput.field.name} is required when ${getFieldName(FIELD_ID.documentType.field.choiceType)} is ${choiceType.name}.`
          }
        }
        break
      case FIELD_ID.documentType.field.choiceMultiTableName:
        fieldType = getFieldInput(FIELD_ID.documentType.field.type)
        if (fieldType.id && makeInteger(fieldType.id) === FIELD_TYPE.multiSelect) {
          if (!fieldInput.currentValue) {
            validationMessage = `${fieldInput.field.name} is required when ${getFieldName(FIELD_ID.documentType.field.type)} is ${fieldType.name}.`
          }
        }
        break
      case FIELD_ID.documentType.field.choiceDisplayColumnName:
        choiceTableName = getFieldInput(FIELD_ID.documentType.field.choiceTableName)
        if (choiceTableName) {
          if (!fieldInput.currentValue) {
            validationMessage = `${fieldInput.field.name} is required when ${getFieldName(FIELD_ID.documentType.field.choiceTableName)} is specified.`
          } else if (fieldInput.changed) {
            const results = await window.apolloClient.query({ query: COLUMN_EXISTS, variables: { tableName: choiceTableName, columnName: fieldInput.currentValue } })
            console.log(results)
            if (!results.data.columnExists) {
              validationMessage = `Column "${choiceTableName}.${fieldInput.currentValue}" does not exist in the database.`
            }
          }
        }
        break
      case FIELD_ID.documentType.field.choicePkColumnName:
        choiceTableName = getFieldInput(FIELD_ID.documentType.field.choiceTableName)
        if (choiceTableName) {
          if (!fieldInput.currentValue) {
            validationMessage = `${fieldInput.field.name} is required when ${getFieldName(FIELD_ID.documentType.field.choiceTableName)} is specified.`
          } else if (fieldInput.changed) {
            const results = await window.apolloClient.query({ query: COLUMN_EXISTS, variables: { tableName: choiceTableName, columnName: fieldInput.currentValue } })
            console.log(results)
            if (!results.data.columnExists) {
              validationMessage = `Column "${choiceTableName}.${fieldInput.currentValue}" does not exist in the database.`
            }
          }
        }
        break
      case FIELD_ID.documentType.field.choiceTableName:
        if (fieldInput.currentValue) {
          if (fieldInput.changed) {
            const results = await window.apolloClient.query({ query: TABLE_EXISTS, variables: { tableName: fieldInput.currentValue } })
            console.log(results)
            if (!results.data.tableExists) {
              validationMessage = `Table "${fieldInput.currentValue}" does not exist in the database.`
            }
          }
        } else {
          choiceType = getFieldInput(FIELD_ID.documentType.field.choiceType)
          fieldType = getFieldInput(FIELD_ID.documentType.field.type)
          fieldTypeFieldName = getFieldName(FIELD_ID.documentType.field.type)
          if (fieldType && fieldType.id && choiceType && choiceType.id) {
            if (makeInteger(fieldType.id) === FIELD_TYPE.select || makeInteger(fieldType.id) === FIELD_TYPE.multiSelect) {
              if (makeInteger(choiceType.id) === CHOICE_TYPE.foreignKey) {
                validationMessage = `${fieldInput.field.name} is required when ${fieldTypeFieldName} is ${fieldType.name} and ${getFieldName(FIELD_ID.documentType.field.choiceType)} is ${choiceType.name}.`
              }
            }
          }
        }
        break
      case FIELD_ID.documentType.field.largeChoiceHook:
        if (!fieldInput.currentValue) {
          if (getFieldInput(FIELD_ID.documentType.field.largeChoice) === 'Y') {
            validationMessage = `${fieldInput.field.name} is required when ${getFieldName(FIELD_ID.documentType.field.largeChoice)} is "Yes".`
          }
        }
        break
      case FIELD_ID.documentType.field.choiceType:
        fieldType = getFieldInput(FIELD_ID.documentType.field.type)
        fieldTypeFieldName = getFieldName(FIELD_ID.documentType.field.type)
        if (!fieldInput.currentValue || !fieldInput.currentValue.id) {
          if (makeInteger(fieldType.id) === FIELD_TYPE.select || makeInteger(fieldType.id) === FIELD_TYPE.multiSelect) {
            validationMessage = `${fieldInput.field.name} is required when ${fieldTypeFieldName} is ${fieldType.name}`
          }
        }
        if (fieldInput.currentValue && fieldInput.currentValue.id) {
          if (makeInteger(fieldType.id) !== FIELD_TYPE.select && makeInteger(fieldType.id) !== FIELD_TYPE.multiSelect) {
            validationMessage = `${fieldInput.field.name} should be left blank when ${fieldTypeFieldName} is ${fieldType.name}`
          }
        }
        break
      case FIELD_ID.documentType.field.databaseColumnName:
        fieldType = getFieldInput(FIELD_ID.documentType.field.type)
        fieldTypeFieldName = getFieldName(FIELD_ID.documentType.field.type)
        if (fieldType.id) {
          fieldType = getFieldType(fieldType.id)
          if (fieldType.columnRequired === 'Y') {
            if (fieldInput.currentValue) {
              if (fieldInput.currentValue.indexOf(' ') >= 0) {
                validationMessage = `${fieldInput.field.name} cannot contain spaces.`
              } else {
                const fields = allInputs[FIELD_ID.documentType.fields].currentValue
                const fieldList = allInputs[FIELD_ID.documentType.fields].currentValue.objects
                if (fieldList.length > 1) {
                  let count = 0
                  for (let aField of fieldList) {
                    if (fields[aField.id][FIELD_ID.documentType.field.databaseColumnName].currentValue.toUpperCase() === fieldInput.currentValue.toUpperCase()) {
                      count += 1
                    }
                  }
                  if (count > 1) {
                    validationMessage = `The value "${fieldInput.currentValue}" is used by another field.`
                  }
                }
              }
            } else {
              const dataStoreHook = getFieldInput(FIELD_ID.documentType.field.dataStoreHook)
              if (!dataStoreHook) {
                validationMessage = `${fieldInput.field.name} is required when ${fieldTypeFieldName} is ${fieldType.name}`
              }
            }
          } else {
            if (fieldInput.currentValue) {
              validationMessage = `${fieldInput.field.name} should be left blank when ${fieldTypeFieldName} is ${fieldType.name}`
            }
          }
        }
        break
      case FIELD_ID.documentType.form.submit:
      case FIELD_ID.documentType.form.record:
      case FIELD_ID.documentType.form.reference:
        const formList = allInputs[FIELD_ID.documentType.forms].currentValue.objects
        const formsObject = allInputs[FIELD_ID.documentType.forms].currentValue
        if (fieldInput.currentValue === 'Y' && formList.length > 1) {
          let count = 0
          for (let form of formList) {
            if (formsObject[form.id][fieldInput.field.id].currentValue === 'Y') {
              count += 1
            }
          }
          if (count > 1) {
            validationMessage = `Each document type may have only one form with ${fieldInput.field.name} = "Yes".`
          }
        }
        break
      case FIELD_ID.documentType.tabField.field:
      // Using the same field twice in a tab is prevented by the choice hook
        validationMessage = ''
        break
      case FIELD_ID.queryDetail.line:
        console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ validation hook', allInputs)
        const gridData = allInputs[FIELD_ID.query.details].currentValue.gridData
        const detailsObject = allInputs[FIELD_ID.query.details].currentValue
        let count = 0
        for (let gridDataItem of gridData) {
          if (makeInteger(gridDataItem[0]) !== makeInteger(objectId)) {
            let lineNumber = 0
            if (detailsObject[gridDataItem[0]]) {
              lineNumber = makeInteger(detailsObject[gridDataItem[0]][FIELD_ID.queryDetail.line].currentValue)
            } else {
              lineNumber = gridDataItem[1]
            }
            console.log(lineNumber)
            if (makeInteger(lineNumber) === makeInteger(fieldInput.currentValue)) {
              count += 1
            }
          }
        }
        if (count > 0) {
          validationMessage = `Line value "${fieldInput.currentValue}" is being used by more than one Query Detail item.`
        }
        break
      case FIELD_ID.queryDetail.show:
        const showValue = getFieldInput(FIELD_ID.queryDetail.show)
        if (showValue === 'Y') {
          const selectedField = getFieldInput(FIELD_ID.queryDetail.field)
          console.warn('', selectedField)
          if (selectedField && selectedField.name) {
            if (selectedField.name.includes(':')) {
              validationMessage = `${fieldInput.field.name} cannot be "Yes" for reference list fields (filter only).`
            }
          }
        }
        break
      case FIELD_ID.queryDetail.operator:
        filter = getFieldInput(FIELD_ID.queryDetail.filter)
        if (filter === 'Y') {
          if (!fieldInput.currentValue || (fieldInput.currentValue && !fieldInput.currentValue.id)) {
            validationMessage = `${fieldInput.field.name} is required when ${getFieldName(FIELD_ID.queryDetail.filter)} is "Yes".`
          }
        }
        break
      case FIELD_ID.queryDetail.filterValue:
        filter = getFieldInput(FIELD_ID.queryDetail.filter)
        if (filter === 'Y') {
          if (!fieldInput.currentValue) {
            validationMessage = `${fieldInput.field.name} is required when ${getFieldName(FIELD_ID.queryDetail.filter)} is "Yes".`
          }
        }
        break
      case FIELD_ID.queryDetail.filter:
        if (fieldInput.currentValue === 'Y' && getFieldInput(FIELD_ID.queryDetail.prompt) === 'Y') {
          validationMessage = `${fieldInput.field.name} and ${getFieldName(FIELD_ID.queryDetail.prompt)} cannot both be "Yes".`
        }
        break
      default:
        console.log(`!!!!!!!!!!!!!!!!!!!!!!!!!!!! document_model.validation_hook NOT HANDLED FOR FIELD: ${fieldInput.field.name}`)
        validationMessage = ''
    }
    console.log('validationMessage: ', validationMessage)
    return validationMessage
  },

  choice_hook: async function choice_hook(field, object, parentObjectId, formInputs) {
    const allInputs = window.rootFormInputs
    console.log('document_model.choice_hook', field, object, parentObjectId, formInputs, allInputs)
    let choices = []
    switch (makeInteger(field.id)) {
      case FIELD_ID.queryDetail.field:
        const objectTypeId = makeInteger(window.rootFormInputs[FIELD_ID.query.documentType].currentValue.id)
        const results = await window.apolloClient.query({ query: QUERY_FIELDS, variables: { objectTypeId: objectTypeId } })
        console.log('document_model.choice_hook: ', results)
        choices = results.data.queryFields
        break
      case FIELD_ID.query.batchAction:
        const actions = object.type.actions
        for (let action of actions) {
          if (makeInteger(action.type.id) !== ACTION_TYPE.submit) {
            choices.push({ id: action.id, name: action.name })
          }
        }
        break
      case FIELD_ID.queryDetail.line:
      case FIELD_ID.queryDetail.sortOrder:
        for (let i = 1; i <= 50; i++) {
          choices.push({ id: `${i}`, name: `${i}` })
        }
        break
      case FIELD_ID.queryDetail.operator:
        if (formInputs[FIELD_ID.queryDetail.field].currentValue) {
          const field = makeInteger(formInputs[FIELD_ID.queryDetail.field].currentValue)
          const results = await window.apolloClient.query({ query: OPERATORS, variables: { fieldId: field.id } })
          for (let choice of results.data.operators) {
            choices.push({ id: choice.id, name: choice.name })
          }
          console.log(results)
        }

        break
      case FIELD_ID.documentType.tabField.field:
        console.log('allInputs: ', allInputs)
        const fields = allInputs[FIELD_ID.documentType.fields].currentValue.gridData
        for (field of fields) {
          choices.push({ id: field[0], name: field[1] })
        }
        break
      default:
        console.log(`document_model.choice_hook field "${field.name}" not handled.`)
    }
    return choices
  },

  behavior_hook: async function behavior_hook(object, field, action) {
    console.log('document_model.behavior_hook: ', object, field, action)

    const readOnly = {
      id: BEHAVIOR_TYPE.readOnly,
      name: 'Read Only'
    }
    const mandatory = {
      id: BEHAVIOR_TYPE.mandatory,
      name: 'Mandatory'
    }

    let behaviorType = mandatory

    if (makeInteger(field.id) === FIELD_ID.query.documentType) {
      if (makeInteger(action.type.id) === ACTION_TYPE.modify) {
        behaviorType = readOnly
      }
    }

    console.log('document_model.behavior_hook: ', behaviorType)
    return behaviorType
  }
}

export default document_model
